import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-latest-article',
  templateUrl: './latest-article.component.html',
  styleUrls: ['./latest-article.component.css']
})
export class LatestArticleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  SlideOptions2 = {
    items: 4, margin: 10, dots: true, nav: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      300: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 4
      }

      // 0: {
      //   items: 1
      // },
      // 400: {
      //   items: 2
      // },
      // 740: {
      //   items: 2
      // },
      // 940: {
      //   items: 3
      // }
    },
  };

  Images2 = [
    { title: "The Office of Strategy Management", text:"Why is there such a persistent gap between ambition and performance? The gap...", img: "assets/images/latest_article_img1.png" },
    { title: "Development Articles Programmer", text:"Hello guys, someone asks me another day, would you mind putting...", img: "assets/images/latest_article_img2.png" },
    { title: "How to Be Creative - A Year of Living Better Guides", text:"You know how you’ve got this image of the creator as a somewhat crazy, slightly...", img: "assets/images/latest_article_img3.png" },
    { title: "How to Be Creative - A Year of Living Better Guides", text:"You know how you’ve got this image of the creator as a somewhat crazy, slightly...", img: "assets/images/latest_article_img3.png" },
    // { title: "Automotive and Aircraft", img: "assets/images/latest_article_img2.png" },
    // { title: "Paint", img: "assets/images/latest_article_img2.png" },
    // { title: "Pulp and Paper Mills", img: "assets/images/latest_article_img2.png" },
    // { title: "Waste Water Treatment", img: "assets/images/latest_article_img2.png" },
    // { title: "Beverage water", img: "assets/images/latest_article_img2.png" },
    // { title: "Dairy Industry", img: "assets/images/latest_article_img2.png" },
  ];
}
